import { CommodityTypesSearchRequest } from '@trukt/tms-api/CommodityService';
import { createKey } from './createKey';

const keyHandler = createKey('commodity');

export const CommodityServiceKeys = {
  key: keyHandler.key,
  searchTypes: keyHandler.createMethod<CommodityTypesSearchRequest>(),
};
